import { SVGFC } from '@repo/toolkit/types'

const OpenLinkIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_19062_165452)">
        <path
          d="M18.6663 11.9998C18.4894 11.9998 18.3199 12.0701 18.1949 12.1951C18.0698 12.3201 17.9996 12.4897 17.9996 12.6665V17.3332C17.9996 17.7015 17.7013 17.9998 17.3329 17.9998H6.66626C6.29793 17.9998 5.99959 17.7015 5.99959 17.3332V6.6665C5.99959 6.29817 6.29793 5.99984 6.66626 5.99984H11.3329C11.5097 5.99984 11.6793 5.9296 11.8043 5.80458C11.9294 5.67955 11.9996 5.50998 11.9996 5.33317C11.9996 5.15636 11.9294 4.98679 11.8043 4.86177C11.6793 4.73674 11.5097 4.6665 11.3329 4.6665H6.66626C5.56176 4.6665 4.66626 5.562 4.66626 6.6665V17.3332C4.66626 18.4377 5.56176 19.3332 6.66626 19.3332H17.3329C18.4374 19.3332 19.3329 18.4377 19.3329 17.3332V12.6665C19.3329 12.4897 19.2627 12.3201 19.1377 12.1951C19.0126 12.0701 18.8431 11.9998 18.6663 11.9998ZM19.3329 5.33317V9.33317C19.3329 9.50998 19.2627 9.67955 19.1377 9.80457C19.0126 9.9296 18.8431 9.99984 18.6663 9.99984C18.4894 9.99984 18.3199 9.9296 18.1949 9.80457C18.0698 9.67955 17.9996 9.50998 17.9996 9.33317V6.9425L12.5378 12.4042C12.4118 12.5247 12.2437 12.5911 12.0695 12.5892C11.8952 12.5872 11.7286 12.5171 11.6054 12.3939C11.4822 12.2706 11.4121 12.104 11.4102 11.9298C11.4083 11.7555 11.4747 11.5874 11.5953 11.4615L17.0568 5.99984H14.6663C14.4894 5.99984 14.3199 5.9296 14.1949 5.80458C14.0698 5.67955 13.9996 5.50998 13.9996 5.33317C13.9996 5.15636 14.0698 4.98679 14.1949 4.86177C14.3199 4.73674 14.4894 4.6665 14.6663 4.6665H18.6663C18.8431 4.6665 19.0126 4.73674 19.1377 4.86177C19.2627 4.98679 19.3329 5.15636 19.3329 5.33317Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_19062_165452">
          <rect width="16" height="16" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default OpenLinkIcon
